// extracted by mini-css-extract-plugin
export default {"container":"Vn-z","bubbleNav":"Wn-z","graphic":"Xn-z","contact":"Yn-z"};